import React, { FC } from 'react'
import { Typography } from 'react-components'
import { CTAButton, StyledGhostButton } from '../styles'
import { useTranslation } from '../../../hooks/locale'
import { PdpToCheckoutPosition } from '../constants'
import AnalyticsService from '../../../services/analytics-service'
import { pdpPageCategories } from '../../../services/analytics-service/categories'
import { pdpPageActions } from '../../../services/analytics-service/actions'

type CheckAvailabilityButtonProps = {
    onClick: () => void
    position: PdpToCheckoutPosition
}

const CheckAvailabilityButton: FC<CheckAvailabilityButtonProps> = props => {
    const { t } = useTranslation()
    const { onClick, position } = props

    const onCallClick = () => {
        AnalyticsService.trackEvent({
            category: pdpPageCategories.PDP_PAGE_COMBO,
            action: pdpPageActions.CHECK_AVAILABILITY_BUTTON_CLICKED,
            label: position,
            value: Date.now().toString(),
        })
        onClick()
    }

    return (
        <CTAButton onClick={onCallClick}>
            <StyledGhostButton isPrimary buttonSize="large">
                <Typography variant="subtitle2" fontWeight="semiBold">
                    {t('entitySection.checkAvailability')}
                </Typography>
            </StyledGhostButton>
        </CTAButton>
    )
}

export default CheckAvailabilityButton
